import { MovingObject } from "../entities/MovingObject";
import { TargetRing } from "../entities/TargetRing";
import { distance } from "../utils/Geometry";

export interface CollisionHit {
  object: MovingObject;
  dist: number;
}

export class CollisionSystem {
  checkHits(objects: MovingObject[], target: TargetRing): CollisionHit[] {
    const hits: CollisionHit[] = [];
    for (const obj of objects) {
      if (obj.hasScored) continue;
      const d = distance(obj.x, obj.y, target.x, target.y);
      if (d <= target.radius) {
        hits.push({ object: obj, dist: d });
      }
    }
    return hits;
  }
}
